import OnlineAppComponent from "../lib/online_app_component";
import {AuxHeaderToggle} from "./aux/aux_header_toggle/aux_header_toggle";
import {AuxHeaderCloser} from "./aux/aux_header_closer/aux_header_closer";

export const AuxHeaderConfig = {
    baseHtmlClass: 'online_app__aux__header'
}

export class AuxHeader extends OnlineAppComponent {

    static createElement() {
        let element = document.createElement('header');
        const htmlClass = AuxHeaderConfig.baseHtmlClass;
        element.setAttribute("class", htmlClass);
        return element;
    }

    constructor(onlineAppAux) {
        super(null, onlineAppAux.onlineApp, AuxHeaderConfig);
        this.onlineAppAux = onlineAppAux;
        this.content = null;
        this.element = AuxHeader.createElement();
        this.toggle = new AuxHeaderToggle(this);
        this.closer = new AuxHeaderCloser(this);
    }

    getHeight() {
        try {
            return this.element.offsetHeight;
        } catch {
            return 0;
        }
    }

    setContent(content) {
        this.content = content;
    }

    hasContent() {
        return !!this.content;
    }

    refreshedElement() {
        this.element.innerHTML = this.content;
        this.element.appendChild(this.toggle.element);
        this.element.appendChild(this.closer.element);
        return this.element;
    }
}
